module.exports = __webpack_public_path__ + "static/media/WeStretch-the-stretching-app.832ed01c.png";